<template>
  <v-card flat>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12>
          <v-switch color="primary" label="Habilitado?" v-model="userData.isEnabled" ></v-switch>
        </v-flex>
        <v-flex xs3>
          <v-subheader>Tipo de usuario</v-subheader>
        </v-flex>
        <v-flex xs3>
          <v-select
            v-bind:items="items"
            label="Select"
            single-line
            bottom
            v-model="userData.userType"
          >
          </v-select>
        </v-flex>
        <v-flex xs12>
          asdlaks
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'user-rights-form',
  data () {
    return {
      items: ['GLOBAL', 'NORMAL', 'SUPERVISOR']
    }
  },

  props: ['userData', 'userSubscriptions']
}
</script>



// WEBPACK FOOTER //
// src/components/users/user-rights-form.vue